export default [
  {
    title: 'ID',
    key: 'id',
    width: 48
  },
  {
    title: '创意标签组标题',
    key: 'title',
    width: 80,
    overflow: true
  },
  {
    title: '标签',
    key: 'labelDetailList',
    overflow: true
  },
  {
    title: '创建人',
    key: 'opName',
    width: 64
  },
  {
    title: '更新人',
    key: 'upOpName',
    width: 64
  },
  {
    title: '更新时间',
    key: 'updateTime',
    width: 80
  },
  {
    title: '操作',
    key: 'control',
    width: 80
  }
]
